import React from 'react';
import styles from 'signer-app/signature-modal/common/buttons-divider.module.css';

export const ButtonsDivider = () => <div className={styles.buttonsDivider} />;
